export const currencyFormatter = ({locale, notation = 'standard', compactDisplay = 'long', style = 'currency' }) => {
    const options = {
        style: style,
        currency: 'EUR',
        minimumFractionDigits: 0,
        signDisplay: 'never',
        notation: notation,
        compactDisplay: compactDisplay
    };

    if (style === 'null') {
        delete options.style; // Remove style when style is 'null'
    }

    return new Intl.NumberFormat(locale + '-BE', options);
};

export const generateValueOptions = (max, stringToAdd) => {
    return Array.from({length: max + 1}, (_, i) => ({
        value: i,
        label: i === max && stringToAdd ? `${i} ${stringToAdd}` : i
    }));
}

export const splitAddress = (address) => {
    const lastSpaceIndex = address.lastIndexOf(" ");
    const streetNumber = address.substring(0, lastSpaceIndex).trim();
    const boxNumber = address.substring(lastSpaceIndex + 1).trim();

    return [streetNumber, boxNumber];
}

// TODO: below can possible be replaced by config setting in INTL.NumberFormat
export const roundToThousand = (number) => {
  return Math.round(number / 1000) * 1000;
}